import React from 'react';
import PropTypes from 'prop-types';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import cidData from '../../assets/tabelaCID10.json';

const CidAutocomplete = ({ value = '', onChange }) => {
  return (
    <Autocomplete
      id="cid-autocomplete"
      options={cidData}
      getOptionLabel={(option) => `${option.codigo} - ${option.nome}`}
      value={cidData.find((item) => item.codigo === value) || null}
      onChange={(event, newValue) => {
        if (newValue) {
          onChange(newValue.codigo);
        } else {
          onChange('');
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder="Digite o código ou nome do CID"
          required
        />
      )}
    />
  );
};
CidAutocomplete.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default CidAutocomplete;
